import { atom } from 'jotai'

export interface CreditCardState {
    nameOnCard: string
    cardNumber: string
    expDate: string
    cvv: string
    cardType: string | null
}

export const creditCardState = atom<CreditCardState>({
    nameOnCard: '',
    cardNumber: '',
    expDate: '',
    cvv: '',
    cardType: null
})
